import React, { useEffect, useState } from "react";
import profileBanner from "../../Assets/images/profile-bnr.webp";
import { Link } from "react-router-dom";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import tableImg from "../../Assets/images/table-img.png";
import useMakeRequest from "../../utils/ApiHelper";
import { ApiConstants } from "../../constants/ApiConstants";
import FrontLoader from "../layout/FrontLoader";
import { encodeID, getDate, getPriceHelper, setDateFormat } from "../../utils/Helper";
import { useRef } from "react";
import { PAGINATION, VALIDATION_MESSAGE } from "../../constants/Constants";
import { useNavigate } from "react-router-dom";
import Swal from 'sweetalert2'
import { LanguageConstants } from "../../constants/LanguageConstants";
import { Modal } from "react-bootstrap";
import OrderCancelMessage from "../../Modal/OrderCancelMessage";
import OrderCancel from "../../Modal/OrderCancel";
import MessageHistoryModal from "../../Modal/MessageHistoryModal";
import Shippingdetails from "../../Modal/Shippingdetails";
import shipping_tracking from "../../Assets/images/shipping_tracking.png";


function Order() {
    const OrderList = useMakeRequest()
    const [status, setStatus] = useState('')
    const [search, setSearch] = useState('')
    const [start_date, setStartDate] = useState<any>('')
    const [end_date, setEndDate] = useState<any>('')
    const formRef = useRef<HTMLFormElement>(null);
    const [searchStatus, setSearchStatus] = useState(false)
    const [messageshow, setMessageShow] = useState(false)
    const [cancelShow, setCancelShow] = useState(false)
    const [sendData, setsendData] = useState({})
    const [pagination, setPagination] = useState<any>({ pageIndex: PAGINATION?.PAGE, pageSize: PAGINATION?.PAGESIZE });
    const navigate = useNavigate()
    const [historyData, setHistoryData] = useState({})
    const [show, setShow] = useState(false)
    const [showShipping , setShowShipping] = useState(false)


    useEffect(() => {
        const payload = {
            status: status,
            start_date: setDateFormat(start_date),
            end_date: setDateFormat(end_date),
            search: search?.trim(),
            page: pagination.pageIndex,
            pageSize: pagination.pageSize,
        }
        OrderList.makeRequest({ payload, url: ApiConstants?.OrderGet, toastStatus: false })
    }, [searchStatus, status, pagination])

    const handleStartDateInput = (e: any) => {
        setStartDate(e)
    }

    const handleEndDateInput = (e: any) => {
        setEndDate(e)
    }
    //  search data 
    const handleSearch = (e: any) => {
        e.preventDefault()
        setSearchStatus(!searchStatus)
    }
    //  reset search inputs
    const handleReset = () => {
        if (formRef.current) {
            formRef.current.reset();
        }
        setStartDate('')
        setEndDate('')
        setSearch('')
        setSearchStatus(!searchStatus)
    }
    const handleIncreasePageSize = () => {
        setPagination((prevState: any) => ({
            ...prevState,
            pageSize: prevState.pageSize + 10
        }));
    };

    const handleNavigate = (e: any) => {
        navigate(`/order-detail/${encodeID(e?.uuid)}`)
    }

    // open message history modal show
    const handleMessageHistory = (e: any) => {
        setHistoryData(e)
        setShow(true)
    }


    return (
        <>
            {(OrderList?.loading) ? <FrontLoader /> : null}
            <main>
                {/* top banner section start */}
                <section
                    className="main-banner small-banner"
                    style={{ background: `url(${profileBanner}) center/cover` }}
                >
                    <div className="container">
                        <h1 className="small-banner-heading">{LanguageConstants?.MYORDER}</h1>
                        <nav className="com-breadcrumb" aria-label="breadcrumb">
                            <ol className="breadcrumb">
                                <li className="breadcrumb-item"><Link to="/profile">{LanguageConstants?.PROFILE}</Link></li>
                                <li className="breadcrumb-item active" aria-current="page">{LanguageConstants?.MYORDER}</li>
                            </ol>
                        </nav>
                    </div>
                </section>
                {/* top banner section end  */}

                <div className="footer-space">
                    <div className="container">

                        <form ref={formRef} onSubmit={handleSearch}>
                            <div className="top-bar-area">
                                <h2 className="title-1 mb-2">{LanguageConstants?.ORDERLIST}</h2>
                                <div className="top-bar-right">
                                    <div className="top-bar-date">
                                        <label>{LanguageConstants?.FROM}</label>
                                        <DatePicker
                                            className='form-control'
                                            placeholderText={LanguageConstants?.DATETYPE}
                                            timeFormat="MM DD YYYY"
                                            selected={start_date}
                                            onKeyDown={(e: any) => e.preventDefault()}
                                            onChange={handleStartDateInput}
                                        />
                                    </div>
                                    <div className="top-bar-date">
                                        <label>{LanguageConstants?.TO}</label>
                                        <DatePicker
                                            className='form-control'
                                            placeholderText={LanguageConstants?.DATETYPE}
                                            timeFormat="MM DD YYYY"
                                            disabled={start_date ? false : true}
                                            minDate={start_date}
                                            selected={end_date}
                                            onKeyDown={(e: any) => e.preventDefault()}
                                            onChange={handleEndDateInput}
                                        />
                                    </div>
                                    <div className="top-bar-search">
                                        <i className="icon-search"></i>
                                        <input type="text" className="form-control" placeholder={LanguageConstants?.ORDER_FILLTER_INPUT} onChange={(e: any) => setSearch(e?.target?.value)} />

                                    </div>
                                    <button type="submit" className="round-btn" onClick={(e: any) => handleSearch(e)} >{LanguageConstants?.Filter}</button>
                                    <button className="round-btn round-btn-outline" onClick={() => handleReset()} >{LanguageConstants?.Reset}</button>
                                </div>
                            </div>
                        </form>


                        <div className="quotation-box">
                            <ul className="nav nav-pills" id="pills-tab" role="tablist">
                                <li className="nav-item" role="presentation">
                                    <button className="nav-link active" id="pills-all-tab" data-bs-toggle="pill" onClick={() => setStatus('')} data-bs-target="#pills-all" type="button" role="tab" aria-controls="pills-all" aria-selected="true">{LanguageConstants?.ALL}</button>
                                </li>
                                {/* <li className="nav-item" role="presentation">
                            <button className="nav-link" id="pills-pending-tab" data-bs-toggle="pill" onClick={()=>setStatus('0')} data-bs-target="#pills-pending" type="button" role="tab" aria-controls="pills-pending" aria-selected="false">Pending</button>
                        </li> */}
                                <li className="nav-item" role="presentation">
                                    <button className="nav-link" id="pills-progress-tab" data-bs-toggle="pill" onClick={() => setStatus('4')} data-bs-target="#pills-progress" type="button" role="tab" aria-controls="pills-progress" aria-selected="false">{LanguageConstants?.Progress}</button>
                                </li>
                                <li className="nav-item" role="presentation">
                                    <button className="nav-link" id="pills-In-Transit-tab" data-bs-toggle="pill" onClick={() => setStatus('1')} data-bs-target="#pills-In-Transit" type="button" role="tab" aria-controls="pills-In-Transit" aria-selected="false">{LanguageConstants?.INTRANSIT}</button>
                                </li>
                                <li className="nav-item" role="presentation">
                                    <button className="nav-link" id="pills-delivered-tab" data-bs-toggle="pill" onClick={() => setStatus('2')} data-bs-target="#pills-delivered" type="button" role="tab" aria-controls="pills-delivered" aria-selected="false">{LanguageConstants?.DELIVERD}</button>
                                </li>
                                <li className="nav-item" role="presentation">
                                    <button className="nav-link" id="pills-cancelled-tab" data-bs-toggle="pill" onClick={() => setStatus('3')} data-bs-target="#pills-cancelled" type="button" role="tab" aria-controls="pills-cancelled" aria-selected="false">{LanguageConstants?.CANVELLED}</button>
                                </li>
                            </ul>
                            <div className="tab-content" id="pills-tabContent">
                                <div className="tab-pane fade show active" id="pills-all" role="tabpanel" aria-labelledby="pills-all-tab">
                                    <div className="table-responsive">
                                        <table className="table">
                                            <thead>
                                                <tr>
                                                    {/* <th className="text-center">{LanguageConstants?.SNO}</th> */}
                                                    <th className="text-start">{LanguageConstants?.ORDERID}</th>
                                                    <th className="text-start">{LanguageConstants?.ORDERQUOTATIONID}</th>
                                                    <th className="text-start">{LanguageConstants?.DATE}</th>
                                                    <th className="text-start">{LanguageConstants?.AMOUNT}</th>
                                                    <th className="text-start">{LanguageConstants?.PAYMENTSTATUS}</th>
                                                    <th className="text-start">{LanguageConstants?.DELIVERYSTATUS}</th>
                                                    {/* <th className="text-start">{LanguageConstants?.ORRDERDELIVERYADDRESS}</th> */}
                                                    <th className="text-center">{LanguageConstants?.ACTION}</th>
                                                </tr>
                                            </thead>

                                            <tbody>
                                                {OrderList?.data?.data?.rows?.length > 0 ? OrderList?.data?.data?.rows?.map((res: any, i: any) => (
                                                    <tr key={i}>
                                                        {/* <td className="text-center">{i+1}</td> */}
                                                        <td>{res?.uuid}</td>
                                                        <td>{res?.quotation_id}</td>
                                                        <td>{getDate(res?.created_at)}</td>
                                                        <td>${getPriceHelper(res?.total_amount)}</td>
                                                        {res?.payment_status == '0' ? <td className="orange-text">{LanguageConstants?.PENDING}</td> : res?.payment_status == '4' ? <td className="orange-text">{LanguageConstants?.Progress}</td> : res?.payment_status == '1' ? <td className="approved-text">{LanguageConstants?.PAID}</td> : res?.payment_status == '3' ? <td className="red-text">{LanguageConstants?.REFUND}</td> : <td className="red-text">{LanguageConstants?.REJECT}</td>}
                                                        {res?.status == '0' ? <td className="orange-text">{LanguageConstants?.PENDING}</td> : res?.status == '4' ? <td className="orange-text">{LanguageConstants?.Progress}</td> : res?.status == '1' ? <td className="blue-text">{LanguageConstants?.INTRANSIT}</td> : res?.status == '2' ? <td className="approved-text">{LanguageConstants?.DELIVERD}</td> : <td className="red-text">{LanguageConstants?.CANVELLED}</td>}
                                                        {/* <td>{`${res?.street_line}`}</td> */}
                                                        <td>
                                                            <div className="table-action-wrap stop-action">
                                                                <button className="table-action" onClick={() => handleMessageHistory(res)} ><i className="icon-chat" style={{color:'green'}}></i>
                                                                    <span className="action-tooltip">{LanguageConstants?.MESSAGE}</span>
                                                                </button>
                                                                <button className={res?.shipping_company != null ? "table-action" : 'table-action close-action'} onClick={()=>{setShowShipping(true) ; setsendData(res)}}    >
                                                                    <i >
                                                                        <img src={shipping_tracking} alt="shipping_tracking"/>
                                                                    <span className="action-tooltip">{LanguageConstants?.TRACKING}</span>
                                                                </i>
                                                                </button>
                                                                <button className="table-action" onClick={() => handleNavigate(res)} ><i className="icon-view-all">
                                                                    <span className="action-tooltip">{LanguageConstants?.VIEW}</span>
                                                                    
                                                                    </i></button>
                                                                {/* <button className={ res.status == "2" || res.status == "3" || res.is_cancel == "1"  ? "table-action close-action" : "table-action"} onClick={()=>handelCancelOrder(res)} ><i className="icon-close"></i></button> */}
                                                            </div>
                                                        </td>
                                                    </tr>
                                                )) :
                                                    <tr>
                                                        <td colSpan={20}>
                                                            <p className="text-center mt-3">{LanguageConstants?.DATANOTFOUND}</p>
                                                        </td>
                                                    </tr>
                                                }

                                            </tbody>
                                        </table>
                                    </div>
                                    {OrderList?.data?.data?.count > 10 && OrderList?.data?.data?.count > pagination.pageSize
                                        ?
                                        <button className="round-btn mt-4" onClick={() => handleIncreasePageSize()} >More</button>
                                        : null}

                                </div>
                            </div>
                        </div>

                    </div>
                </div>
            </main>
            {/* cancel message show start */}
            <Modal show={messageshow}  >
                <OrderCancelMessage setMessageShow={setMessageShow} setCancelShow={setCancelShow} data={sendData} />
            </Modal>
            {/* cancel message show end */}


            {/* cancel  show start */}
            <Modal show={cancelShow}  >
                <OrderCancel setCancelShow={setCancelShow} data={sendData} />
            </Modal>
            {/* cancel  show end */}

            {/* Message History modal start */}
            <Modal show={show} >
                <MessageHistoryModal data={historyData} setHistoryshow={setShow} />
            </Modal>
            {/* Message History modal end */}

             {/* show shpinng details start */}
                  <Modal show={showShipping}>
                    <Shippingdetails setShow={setShowShipping} data={sendData} />
                  </Modal>
             {/* show shpinng details end */}
            

        </>
    )
}

export default Order